import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getNoPayoutRationales } from 'src/api/no-payout-rationales';
import { enqueueSnackbarAction } from '../notifications/actions';
import { FETCH_NO_PAYOUT_RATIONALES, requestNoPayoutRationales, requestNoPayoutRationalesSuccess } from './actions';

function* fetchNoPayoutRationalesSaga(): SagaIterator {
    yield put(requestNoPayoutRationales());

    const { error, response } = yield call(getNoPayoutRationales);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: `Fehler: NichtAuszahlungsgründe konnten nicht geladen werden --- ${error.message}`,
                options: { key: new Date().getTime() + Math.random(), variant: 'error' },
            })
        );
    } else {
        yield put(requestNoPayoutRationalesSuccess(response));
    }
}

export function* generateFetchNoPayoutRationalesWatcher() {
    yield takeLatest(FETCH_NO_PAYOUT_RATIONALES, fetchNoPayoutRationalesSaga);
}
